import { render, staticRenderFns } from "./BatchTemplatesForm.vue?vue&type=template&id=13db680a&scoped=true&"
import script from "./BatchTemplatesForm.vue?vue&type=script&lang=ts&"
export * from "./BatchTemplatesForm.vue?vue&type=script&lang=ts&"
import style0 from "./BatchTemplatesForm.vue?vue&type=style&index=0&id=13db680a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13db680a",
  null
  
)

export default component.exports